import React, { useContext } from "react";

import { Outlet } from "react-router-dom";
import PanelLayout from "./PanelLayout";
import ScrollToTop from "../../../utils/ScrollToTop";
import FreeConsultationButton from "./FreeConsultationButton";

const AppLayout = () => {

  return (
    <PanelLayout >
      <Outlet />
    </PanelLayout>
  );
};

export default AppLayout;
